import _taggedTemplateLiteral from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  --inset: var(", ");\n\n  ", "\n\n  box-sizing: border-box;\n  padding: var(--inset);\n\n  background-color: var(", ");\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { injectCardShadow } from '../../utils/injectShadow';
import { injectSpacing } from '../../api/spacing/injectSpacing';
export var StyledContentCard = styled.div(_templateObject(), function (props) {
  return props.theme.responsive.spacing.l;
}, injectCardShadow, function (props) {
  return props.theme.colors.background.card;
}, injectSpacing('margin'));